import { useQuery } from '@tanstack/react-query'

import { type ILoadType, type ILoadTypeList } from '../../types'
import { useUpFetch } from '../../utils'

export const useAllLoadTypes = () => {
  const upFetch = useUpFetch()

  return useQuery({
    async queryFn(): Promise<ILoadTypeList> {
      try {
        const res = await upFetch<{ data: ILoadType[] }>(`/public/load-types`)

        // Separate "Any" load type from the rest
        const anyLoadType = res.data.find(item => item.slug === 'any')
        const otherLoadTypes = res.data.filter(item => item.slug !== 'any')

        // First group: Ensure "Any" is included along with the original first 3 items
        const firstGroupOptions = [
          ...(anyLoadType ? [anyLoadType] : []),
          ...otherLoadTypes.slice(0, 3),
        ]

        // Second group: The remaining load types
        const secondGroupOptions = otherLoadTypes.slice(3)

        return [
          {
            hiddenDefault: false,
            options: firstGroupOptions,
          },
          {
            hiddenDefault: true,
            label: 'More',
            options: secondGroupOptions,
          },
        ]
      } catch (error) {
        console.error('Error fetching load types:', error)
        return []
      }
    },
    queryKey: ['/public/load-types'],
  })
}
